import { createRouter, createWebHistory, RouteRecordRaw } from '@core/global';
import { useAuthStore } from '@core/stores/auth'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: () => import('../layout/Main.vue'),
        children: [
            {
                path: '',
                name: 'Home',
                component: () => import('../pages/Home.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'login',
                name: 'Login',
                component: () => import('../pages/Login.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'member',
                name: 'Membership',
                component: () => import('../pages/Membership.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'member-registration',
                name: 'MembershipRegistration',
                component: () => import('../pages/MembershipRegistration.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'updates',
                name: 'Updates',
                component: () => import('../pages/Updates.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'update/:id',
                name: 'UpdateSingle',
                props: true,
                component: () => import('../pages/UpdateSingle.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'faqs',
                name: 'FAQs',
                component: () => import('../pages/FAQs.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'about',
                name: 'About',
                component: () => import('../pages/About.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'contact',
                name: 'Contact',
                component: () => import('../pages/Contact.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'blog',
                name: 'Blog',
                component: () => import('../pages/Blog.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'blog/:slug',
                name: 'BlogSingle',
                props: true,
                component: () => import('../pages/BlogSingle.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'p/:slug',
                name: 'Page',
                props: true,
                component: () => import('../pages/Page.vue'),
                meta: { requiresAuth: false }
            },
            {
                path: 'page/:slug',
                name: 'Page',
                props: true,
                component: () => import('../pages/Page.vue'),
                meta: { requiresAuth: false }
            },

            {
                path: 'member-account',
                name: 'MemberAccount',
                component: () => import('../pages-account/AccountLayout.vue'),
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: 'MemberInfo',
                        component: () => import('../pages-account/AccountInfo.vue')
                    },
                    {
                        path: 'info',
                        name: 'AccountInfo',
                        component: () => import('../pages-account/AccountInfo.vue')
                    },
                    {
                        path: 'programmes',
                        name: 'ProgrammesSubscribed',
                        component: () => import('../pages-account/ProgrammesSubscribed.vue')
                    },
                    {
                        path: 'events',
                        name: 'EventsParticipated',
                        component: () => import('../pages-account/EventsParticipated.vue')
                    },
                    {
                        path: 'updates',
                        name: 'MemberUpdates',
                        component: () => import('../pages-account/MemberUpdates.vue')
                    }
                ]
            },
            {
                path: ':pathMatch(.*)*',
                props: true,
                name: 'Page',
                component: () => import('../pages/Page.vue'),
            }
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@core/pages/NotFound.vue')
    }
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
    const authStore = useAuthStore()
    const requiresAuth = to.meta.requiresAuth

    if (requiresAuth && !authStore.isAuthenticated) {
        next({ name: 'Login', query: { redirect: to.fullPath } })
    } else if ((to.name === 'Login' || to.name === 'Register') && authStore.isAuthenticated) {
        next({ name: 'Dashboard' })
    } else {
        next()
    }
})

export default router
